<template>
  <div class="c-button">
    <div class="c-col-field">{{ description }}</div>
    <div class="c-caption">
      <el-select v-model="selectBtn" multiple placeholder="请选择">
        <el-option v-for="item in enumeration" :key="item.key" :value="item.value" :label="item.value" :disabled="isDisabled(item.value)">
        </el-option>
      </el-select>
    </div>
    <div v-if="msg" class="c-col-msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixinVerify from './mixin-verify'
export default {
  name: 'CButton',
  mixins: [mixinVerify],
  props: {
    value: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    enumeration: {
      type: Array,
      default() {
        return []
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    verify: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    selectBtn: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    isDisabled() {
      return (item) => {
        return !this.selectBtn.includes(item) && this.selectBtn.length > 1
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.c-button {
  width: 100%;
  position: relative;
  z-index: 5;
  display: flex;

  .c-col-field {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 120px;
    line-height: 32px;
    text-align: right;
    padding-right: 12px;
  }

  .c-caption {
    width: 220px;
  }

  .c-col-msg {
    position: absolute;
    z-index: 4;
    left: 119px;
    bottom: -12px;
    color: #ff4400;
  }
}
</style>
